module.exports = __webpack_public_path__ + "static/assets/c019f6ed0fc028c1f003f1fb6eecaf8e.gif";